import DomainCommon from './common';

const CalenderService = {
    list: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/events`,
                resolve, reject
            });
        });
    },
    workEventListByDate: (date_str) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/workEvent/query?date_str=${date_str}`,
                resolve, reject
            });
        });
    },
    lmWorkEventListByDate: (date_str) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/leaderMedicalWorkEvent/query?date_str=${date_str}`,
                resolve, reject
            });
        });
    },
    fmWorkEventListByDate: (date_str) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/firefighterMedicalWorkEvent/query?date_str=${date_str}`,
                resolve, reject
            });
        });
    },
};

export default CalenderService;



// WEBPACK FOOTER //
// ./src/service/calender.js